<app-process-editor [readOnly]="true" [cerrixTab]="tab"></app-process-editor>
